import ProductModalEnhancement from './modules/product-modal-enhancement';
import ImageResolutionEnhancement from './modules/image-resolution-enhancement';

function initCustomScripts() {
  new ProductModalEnhancement();
  new ImageResolutionEnhancement();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomScripts);
} else {
  initCustomScripts();
}